import { useQuery } from '@fv/client-core'
import type { AccountUsersQuery } from '@fv/models/admin'

import { adminFetch } from '@/utils'

import type { AccountUserModel } from '../types'

export const accountUsersQueryKeys = {
  all: ['account-users'],
  account: (id?: string, query?: AccountUsersQuery) => [
    ...accountUsersQueryKeys.all,
    ...(id ? [id] : []),
    ...(query ? [query] : []),
  ],
  user: (accountId: string, userId: string) => [
    ...accountUsersQueryKeys.account(accountId),
    userId,
  ],
}
export function useAccountUsers(id?: string, query?: AccountUsersQuery) {
  return useQuery(
    accountUsersQueryKeys.account(id, query),
    () => adminFetch<AccountUserModel[]>(`/accounts/${id}/users`, { query }),
    {
      enabled: !!id,
    },
  )
}

interface UseAccountUserProps {
  accountId: string
  userId: string
}
export const useAccountUser = ({ accountId, userId }: UseAccountUserProps) => {
  return useQuery(
    accountUsersQueryKeys.user(accountId, userId),
    () =>
      adminFetch<AccountUserModel>(`/accounts/${accountId}/users/${userId}`),
    {
      enabled: !!accountId && !!userId,
      staleTime: Infinity,
    },
  )
}
